import { useEffect, useState, lazy } from 'react';
import { AnyRouter } from '@tanstack/react-router';

import {
	TanStackDevtools,
	TanStackDevtoolsReactPlugin,
} from '@tanstack/react-devtools';
import {
	TanStackRouterDevtoolsPanel,
	TanStackRouterDevtoolsPanelInProd,
} from '@tanstack/react-router-devtools';

import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
const ReactQueryDevtoolsPanelInProd = lazy(() =>
	import('@tanstack/react-query-devtools/build/modern/production.js').then(
		(d) => ({
			default: d.ReactQueryDevtoolsPanel,
		}),
	),
);

import { useHotkey } from '@tanstack/react-hotkeys';
import { HotkeysDevtoolsPanel } from '@tanstack/react-hotkeys-devtools';

const isDev = import.meta.env.MODE === 'development';

export function DevTools({ router }: DevToolsProps) {
	const [showDevtools, setShowDevtools] = useState(isDev);
	const toggleDevtools = () => {
		setShowDevtools((old) => !old);
	};
	useHotkey('Shift+D', () => {
		toggleDevtools();
	});
	useEffect(() => {
		window.toggleDevtools = toggleDevtools;
	}, []);

	const QueryDevTools = isDev ? (
		<ReactQueryDevtoolsPanel />
	) : (
		<ReactQueryDevtoolsPanelInProd />
	);
	const RouterDevTools = isDev ? (
		<TanStackRouterDevtoolsPanel router={router} />
	) : (
		<TanStackRouterDevtoolsPanelInProd router={router} />
	);

	const HotKeysDevTools = <HotkeysDevtoolsPanel />;

	const plugins: Array<TanStackDevtoolsReactPlugin> = [
		{
			name: 'TanStack Query',
			render: QueryDevTools,
		},
		{
			name: 'TanStack Router',
			render: RouterDevTools,
		},
	];

	if (isDev) {
		plugins.push({
			name: 'TanStack Hotkeys',
			render: HotKeysDevTools,
		});
	}

	return (
		<>
			{showDevtools && (
				<TanStackDevtools
					config={{
						position: 'bottom-left',
						panelLocation: 'bottom',
					}}
					plugins={plugins}
				/>
			)}
		</>
	);
}

interface DevToolsProps {
	router?: AnyRouter;
}
